module.exports = __webpack_public_path__ + "img/oef.e3c03ab0.webp";